// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"ce259940","985":"d3a0a36b"}[chunkId] + ".chunk.css";
};